// extracted by mini-css-extract-plugin
export default {"messageCol":"ProlongationTable_messageCol__BRnE6","tableLoading":"ProlongationTable_tableLoading__xMXAL","table":"ProlongationTable_table__2GbaC"};